import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AgentClientService } from './agent-client.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [AgentClientService],
})
export class AgentClientModule {}
